import { AppButton, AppTextField } from 'components';
import { memo, useContext, useEffect, useState } from 'react';
import { ReactSortable } from 'react-sortablejs';
import Editor from 'components/CKEditor/Editor';
import { getRandomUid } from 'utilities/uuid.service';
import * as AppPics from 'assets/images';
import { EditorPreviewContext } from 'context/EditorPreviewContext';
import useDebounce from 'hooks/useDebounce';
import { removeHtmlTags } from 'utilities/fns';

function FillInTheBlanks({ handleSave, data }) {
  const { PreviewBtn } = useContext(EditorPreviewContext);

  const [currentEdited, updateCurrentEditBlock] = useState({});

  const editorData = useDebounce(currentEdited, 100);

  useEffect(() => {
    if (editorData.id) {
      updateCurrentEditBlock(editorData);
      handleSave({
        options: data?.options?.map((x) => {
          if (x.id === editorData.id) x.option = editorData.data;
          return x;
        }),
      });
    }
  }, [editorData]);
  return (
    <div className="tab__content-actBody">
      <div className="px-5">
        <div className="row mt-4">
          <div className="col-md-12 col-lg-12 col-sm-12">
            <div className="lessonWrap lessonWrap--border topalign __fill__up__blanks_sub">
              <div className="w-100 p-3">
                <label htmlFor="questionToFill">Question</label>
                {data?.title && <PreviewBtn block={{ value: data.title }} />}
                <Editor
                  data={{
                    value: data?.title || '',
                    onChange: (editorData) => {
                      handleSave({ title: editorData });
                    },
                  }}
                  config={{
                    placeholder: 'Enter only the question here.',
                  }}
                />
              </div>

              <div className="col-12">
                <label htmlFor="questionToFill">
                  Add the correct choices in order as per the blanks.
                </label>
              </div>
              <ReactSortable
                list={data?.options}
                setList={(newState) =>
                  handleSave({
                    options: newState,
                  })
                }
                handle=".grabHandleID"
              >
                {data?.options
                  ?.map((choice) => ({ ...choice, option: removeHtmlTags(choice.option) }))
                  ?.map((choice, index) => {
                    return (
                      <div className="lessonWrap  topalign py-0 grabHandleID" key={choice.id}>
                        <div className="w-100 p-3">
                          <label htmlFor="">Choice #{index + 1}</label>
                          <AppButton
                            variantClass="lessonWrap__btn leftpos dublicate"
                            title="Clone"
                            onClick={() => {
                              handleSave({
                                options: data?.options?.concat({
                                  id: getRandomUid(),
                                  option: choice.option,
                                }),
                              });
                            }}
                          >
                            <img src={AppPics.StampSvg} alt="clone this option" />
                          </AppButton>
                          <AppButton
                            variantClass="lessonWrap__btn leftpos delete"
                            onClick={() => {
                              handleSave({
                                options: data?.options?.filter((x) => x.id !== choice.id),
                              });
                            }}
                          >
                            <img src={AppPics.DeleteSvg} alt="delete this option" />
                          </AppButton>
                          {choice.option && <PreviewBtn block={{ value: choice.option }} />}
                          <AppTextField
                            labelProps={{ label: ' ' }}
                            inputProps={{
                              placeholder: 'Please provide your choice here',
                              value: choice.option,
                              onChange: (event) => {
                                handleSave({
                                  options: data?.options?.map((x) => {
                                    if (x.id === choice.id) x.option = event.target.value;
                                    return x;
                                  }),
                                });
                              },
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
              </ReactSortable>

              <div className="col-12">
                <AppButton
                  variantClass="btn-plane p--tint m-l-btn"
                  onClick={() => {
                    handleSave({
                      options: data?.options?.concat({
                        id: getRandomUid(),
                        option: '',
                      }),
                    });
                  }}
                >
                  + Add Choice
                </AppButton>
              </div>

              <div className="w-100 p-3 mt-4">
                <label htmlFor="">Hint</label>
                {data?.hint && <PreviewBtn block={{ value: data?.hint || '' }} />}
                <Editor
                  data={{
                    value: data?.hint || '',
                    onChange: (data) => handleSave({ hint: data }),
                  }}
                />
              </div>

              <div className="w-100 p-3">
                <label htmlFor="">Explanation</label>
                {data?.explanation && <PreviewBtn block={{ value: data?.explanation || '' }} />}
                <Editor
                  data={{
                    value: data?.explanation || '',
                    onChange: (data) => handleSave({ explanation: data }),
                  }}
                />
              </div>
              <div className="w-100 p-3">
                <AppTextField
                  labelProps={{ label: 'Marks' }}
                  inputProps={{
                    placeholder: 'Please provide the maximum marks allocated',
                    value: data?.marks || '',
                    onChange: (event) => handleSave({ marks: event.target.value }),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(FillInTheBlanks);
